import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { ReactNode } from 'react';

interface Props {
  text: string | ReactNode;
  title?: string;
  onYes: () => void;
  onNo: () => void;
  /**
   * Which is the primary action (the one that appears on the right bottom of the modal)?
   * Default: Y */
  primaryAction?: 'Y' | 'N';
  yesLabel?: string;
  noLabel?: string;
}

export const ConfirmationModal = ({
  text, onYes, onNo, title, primaryAction = 'Y', yesLabel, noLabel,
}: Props) => (
  <Dialog open>
    <div className="p-6">
      <div className="relative">
        <h1 className="text-lg font-semibold">{title || 'Confirm'}</h1>
      </div>
      <div className="py-4">
        {text}
      </div>
      <DialogActions>
        {(primaryAction === 'Y')
          ? (
            <>
              <button type="button" className="btn-primary-outlined" onClick={onNo} color="inherit">
                {noLabel || 'No'}
              </button>
              <button type="button" className="btn-primary" onClick={onYes} color="primary">
                {yesLabel || 'Yes'}
              </button>
            </>
          )

          : (
            <>
              <button type="button" className="btn-primary" onClick={onNo} color="primary">
                {noLabel || 'No'}
              </button>
              <button type="button" className="btn-primary-outlined" onClick={onYes} color="inherit">
                {yesLabel || 'Yes'}
              </button>
            </>
          )}
      </DialogActions>
    </div>
  </Dialog>
);
